import React, { useState } from 'react';
import { Container, Form, Button, Alert } from 'react-bootstrap';
import axios from 'axios';

export default function Login({ setToken }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const API_BASE = 'https://r2-object-manager.vijay-vishwakarma.workers.dev';
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      // Try to list objects as auth check
      const res = await axios.get(`${API_BASE}/api/list`, {
        headers: {
          Authorization: 'Basic ' + btoa(`${username}:${password}`)
        }
      });
      if (res.status === 200) {
        const token = btoa(`${username}:${password}`);
        localStorage.setItem('token', token);
        setToken(token);
      }
    } catch {
      setError('Invalid credentials');
    }
  };

  return (
    <Container className="mt-5" style={{ maxWidth: 400 }}>
      <h2 className="mb-4">Login</h2>
      {error && <Alert variant="danger">{error}</Alert>}
      <Form onSubmit={handleSubmit}>
        <Form.Group className="mb-3">
          <Form.Label htmlFor="username">Username</Form.Label>
          <Form.Control id="username" value={username} onChange={e => setUsername(e.target.value)} required />
        </Form.Group>
        <Form.Group className="mb-3">
          <Form.Label htmlFor="password">Password</Form.Label>
          <Form.Control id="password" type="password" value={password} onChange={e => setPassword(e.target.value)} required />
        </Form.Group>
        <Button type="submit" variant="primary" className="w-100">Login</Button>
      </Form>
    </Container>
  );
}
